import React from 'react';
import { Outlet } from 'react-router-dom';
import PlatformFooter from '../../components/PlatformFooter';
import TenantHeader from '../../components/TenantHeader';
import { useAuth } from '../../context/AuthContext';
import { useComsAvailability } from '../../context/ComsContext';
import { communityNavigation, membershipNavigation } from '../../utils/communityNavigation';

export default function CommunityShell() {
  const { activeTenant, isModuleEnabled, access, user, memberships = [] } = useAuth();
  const { comsEnabled } = useComsAvailability();
  const active = memberships.filter((entry) => entry.status === 'active' && entry.tenantSlug);
  const navigation = activeTenant?.slug
    ? communityNavigation({
      base: `/t/${activeTenant.slug}`, tenantId: activeTenant._id, user,
      role: access?.communityRoles?.[activeTenant._id], enabled: isModuleEnabled,
    })
    : active.map((membership) => ({
      label: membership.branding?.displayName || membership.tenantName || membership.tenantSlug,
      children: membershipNavigation(membership, user).flatMap((item) => item.children || [item]),
    }));
  const coms = comsEnabled && (activeTenant ? isModuleEnabled('coms') : active.some((entry) => entry.allowedModules?.coms));
  const nav = [{ to: '/dashboard', label: 'My communities' }, ...navigation, { to: '/membership', label: 'Memberships' },
    ...(coms ? [{ to: '/coms', label: 'Coms Hub' }] : [])];
  return <div className="shell shell--community">
    <TenantHeader tenant={activeTenant} navItems={nav} />
    <main className="shell-content--full"><Outlet /></main>
    <PlatformFooter />
  </div>;
}
